module.exports = __webpack_public_path__ + "img/PersonIcon.efd05f3f.svg";